import { GovField } from "@publicMirage/components/govReact/GovField";
import { ErrorText, FormGroup, H3, LabelText } from "govuk-react";
import React, { memo, useEffect } from "react";
import { useForm } from "../hooks/formContext";
import { PrePpWlTypeOfBuildDevelopmentTypes, PrePpWlTypeOfNewBuildDevelopmentTypes } from "@shared/prePublicPortalWestLindsay/contracts/IPrePpWlForm";

export const BuildNewDwellingsType = memo(() => {
    const { toFieldProps, formState, getFieldProp, setFieldValue } = useForm();
    const { developmentScale } = formState;
    const errorMsg = getFieldProp("developmentScale", "errorMsg");
    const errorNewBuildMsg = getFieldProp("typeOfNewBuild", "errorMsg");

    useEffect(() => {
        setFieldValue("typeOfNewBuild", "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [developmentScale.value]);

    return (
        <>
            <H3>Type B: Build new dwellings</H3>
            <GovField {...toFieldProps("totalNumberOfUnitsProposed", "TEXT")} />
            <FormGroup error={!!errorMsg}>
                <LabelText className="required">Scale of development</LabelText>
                <ErrorText>{errorMsg}</ErrorText>
                <GovField {...toFieldProps("developmentScale", "RADIO", PrePpWlTypeOfBuildDevelopmentTypes.NEW_BUILD)} label="New Build" />
                <GovField {...toFieldProps("developmentScale", "RADIO", PrePpWlTypeOfBuildDevelopmentTypes.CONVERSION)} label="Conversion (e.g. house into flats)" />
            </FormGroup>

            {developmentScale.value === PrePpWlTypeOfBuildDevelopmentTypes.NEW_BUILD ? (
                <FormGroup error={!!errorNewBuildMsg}>
                    <LabelText className="required">Types of new build</LabelText>
                    <ErrorText>{errorNewBuildMsg}</ErrorText>
                    <GovField {...toFieldProps("typeOfNewBuild", "RADIO", PrePpWlTypeOfNewBuildDevelopmentTypes.FLAT)} label="Flat" />
                    <GovField {...toFieldProps("typeOfNewBuild", "RADIO", PrePpWlTypeOfNewBuildDevelopmentTypes.HOUSE)} label="House" />
                    <GovField {...toFieldProps("typeOfNewBuild", "RADIO", PrePpWlTypeOfNewBuildDevelopmentTypes.BUNGALOW)} label="Bungalow" />
                    <GovField {...toFieldProps("typeOfNewBuild", "RADIO", PrePpWlTypeOfNewBuildDevelopmentTypes.MIXED)} label="Mixed" />
                </FormGroup>
            ) : null}
        </>
    );
});
